import { isNode } from '../treeVisitors/helpers';
import { isObject } from '../typeUtils';

const callAllWith =
  (fns) =>
  (...args) => {
    return fns.reduce((acc, fn) => {
      const additionalArgs = (fn && fn(...args)) || {};
      const shouldAddAdditionalArgs =
        isObject(additionalArgs) &&
        !isNode(additionalArgs) &&
        !additionalArgs.name;
      return shouldAddAdditionalArgs ? { ...acc, ...additionalArgs } : acc;
    }, {});
  };

export const traverseTree = (tree, visitors = [], additionalArgs) => {
  Object.entries(tree).forEach(([nodeKey, node]) => {
    if (isObject(node)) {
      const additionalArgsForNextNode = callAllWith(visitors)(
        node,
        nodeKey,
        additionalArgs,
      );
      traverseTree(node, visitors, additionalArgsForNextNode);
    }
  });
};
